import { useT } from '../i18n'
import { FLEET_SEGMENTS, type FleetSegment } from './fleetSegments'

interface FleetToggleProps {
  segments: FleetSegment[]
  onToggle: (s: FleetSegment) => void
}

/** Сегменты флота: три независимых кнопки-фильтра живых AIS-позиций.
 *
 *  «Свой» / «Нацфлот» / «Инофлот» включаются в любой комбинации — источник у всех
 *  один (ais_vessel), точки дедуплицируются по mmsi на фронте, поэтому «свой» и
 *  национальный больше не рисуют свои суда дважды. «Инофлот» больше не заглушён:
 *  живой стрим даёт координаты и иностранного флота.
 *
 *  Подпись средней кнопки — «национальный флот», а не «РФ»: на англоязычном
 *  домене фильтр не должен называть страну. Идентификатор сегмента с 14.08.2026
 *  зовётся так же — 'nat'; прежнее 'ru' понимается ради старых ссылок. Какой
 *  флаг попадёт в выборку, решает бэкенд (`NATIONAL_FLAG`). */
export function FleetToggle({ segments, onToggle }: FleetToggleProps) {
  const t = useT()
  return (
    <div className="flex flex-col gap-1">
    <div className="flex gap-1 rounded-lg bg-trench p-1">
      {FLEET_SEGMENTS.map(o => {
        const on = segments.includes(o.id)
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onToggle(o.id)}
            aria-pressed={on}
            className={[
              'flex-1 rounded-md px-2 py-1 text-sm transition-colors',
              on ? 'bg-sonar-dim font-medium text-abyss' : 'text-mist hover:text-foam',
            ].join(' ')}
          >
            {t(o.labelKey)}
          </button>
        )
      })}
    </div>
    </div>
  )
}
